var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScoopUpImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 416,
    viewBox: "0 0 377 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.297 0L376.716 115.628L281.758 210.586C229.313 263.03 132.532 279.661 65.5896 247.731C-1.35262 215.801 -13.1056 147.403 39.3384 94.9584L134.297 0Z",
    fill: "url(#paint0_linear_1170_5980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.983 202.391C147.427 149.946 244.209 133.316 311.151 165.246C378.093 197.176 389.846 265.574 337.402 318.019L242.444 412.977L0.0245434 297.349L94.983 202.391Z",
    fill: "url(#paint1_linear_1170_5980)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1170_5980",
    x1: 56.155,
    y1: 238.444,
    x2: 167.245,
    y2: 16.5684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.650982,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1170_5980",
    x1: 311.003,
    y1: 158.624,
    x2: 207.262,
    y2: 393.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642358,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoopUpImage);
export default __webpack_public_path__ + "static/media/scoopUpImage.97e6cfb91688d8fd1c8de9a1a3a8bc52.svg";
export { ForwardRef as ReactComponent };